import { HOUSEHOLD_GRID_MIN_SEARCH_LENGTH } from "../constants/constants";

export enum VALIDATION_RESULT_ITEM_CODE {
  Success = 0,
  PropertyValidation = 10,
  DataConflict = 20,
  DataNotFound = 30,
  InvalidOperation = 40,
}

export enum VALIDATION_RESULT_ITEM_TYPE {
  Notice = 10,
  Warning = 20,
  Error = 30,
}

export enum USER_ROLES {
  ADMINISTRATOR = "ADMINISTRATOR",
}

export enum ContactStatus {
  Deceased = "Deceased",
  Active = "Active",
  Inactive = "Inactive",
}

export enum HouseholdDataType {
  NPV = "npv-solution",
  RetirementAge = "client-retirement-age",
  CASetAbFixedIncome = "client-advisor-set-ab-fixed-income",
  AssetsLayout = "client-assets-layout",
}

export enum LTIPType {
  SARs = "SARs",
  RSU = "RSU",
  PSU = "PSU",
  DCP = "DCP",
  CDP = "CDP",
  DLTIP = "DLTIP",
  SRP = "SRP",
}

export enum HOUSEHOLD_GRID_NO_DATA_MSG {
  NoData = "No data to display.",
  QueryTooShort = `Please provide at least ${HOUSEHOLD_GRID_MIN_SEARCH_LENGTH + 1} characters to search.`,
  ErrorLoadingData = "Error loading data.",
}
